import React, {FC} from 'react';

import {Trans} from '../../../libs/shared/core/src/helpers/internationalization/react';
import {PaletteColorsEnum} from '../../../libs/shared/core/src/models/api/paletteModel';
import {Button} from '../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {InfoBubble, InfoBubbleInstanceProps} from '../../../libs/shared/ui/src/components/tip/infoBubble';
import {InfoBubbleContent} from '../../../libs/shared/ui/src/components/tip/infoBubbleContent';
import {InfoBubbleDescription} from '../../../libs/shared/ui/src/components/tip/infoBubbleContentDescription';
import {InfoBubbleTitle} from '../../../libs/shared/ui/src/components/tip/infoBubbleContentTitle';
import {InfoBubbleFooterActions} from '../../../libs/shared/ui/src/components/tip/infoBubbleFooterActions';
import {HighlightPulseStylesEnum} from '../../../libs/shared/ui/src/components/tip/infoBubbleHighlight';
import {VisualSizesEnum} from '../../../libs/shared/ui/src/styles/commonStyles';
import commentComposerImage from '../../assets/images/bubbleTourCommentComposer.png';
import {OnboardingTipTypesEnum} from '../../models/api/preferencesModel';
import {Image} from '../common/image';
import {useOnboardingInfoBubblePresenter} from './onboardingInfoBubbleHook';

/*
 * Component.
 */

export const CommentComposerInfoBubble: FC<InfoBubbleInstanceProps> = ({anchor}) => {
  const {isVisible, closeInfoBubble: onClose} = useOnboardingInfoBubblePresenter(
    OnboardingTipTypesEnum.COMMENT_COMPOSER,
  );

  return (
    <InfoBubble
      position="top"
      anchor={anchor}
      interactionId="p3-comment-composer"
      isVisible={isVisible}
      isInteractive
      highlightPulseStyle={HighlightPulseStylesEnum.TIGHT}
      onRequestClose={onClose}
    >
      <InfoBubbleContent>
        <Image src={commentComposerImage} width={324} height={196} />
        <InfoBubbleTitle>
          <Trans id="infobubble-comment-composer-title">Collaborate with your team</Trans>
        </InfoBubbleTitle>
        <InfoBubbleDescription>
          <Trans id="infobubble-comment-composer-description">
            @mention your teammates to see what they think or leave yourself a private note. (Tip: Want to
            know who can see a comment? Check below the comment bar.)
          </Trans>
        </InfoBubbleDescription>
        <InfoBubbleFooterActions>
          <Button
            onClick={() => {
              onClose();
            }}
            size={VisualSizesEnum.MEDIUM}
            color={PaletteColorsEnum.PINK}
            variant={ButtonVariantsEnum.CUSTOM}
          >
            <Trans id="infobubble-comment-composer-cta">Done</Trans>
          </Button>
        </InfoBubbleFooterActions>
      </InfoBubbleContent>
    </InfoBubble>
  );
};
